/**
 * Configuration of the custom API key authorization scheme we are using to communicate with our API.
 */
export const apiKeyConfig = {
    clientId: 'TheSchoolBusMonitoringReporting_fd9cb1d3554f',
    clientSecret: 'D9CZlS04IUG529EeHI0A+gDBHnGI3pikO4Z4lFyvhO8Q',
};